import VoiceRecorderAzure from './voice-azure';

export const checkAudioDevice = () => {
  return new Promise(resolve => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(stream => {
          stream.getTracks().forEach(track => track.stop());
          resolve({ ok: true });
        })
        .catch(error => {
          resolve({ ok: false, error });
        });
    } else {
      resolve({ ok: false, error: new Error('浏览器不兼容') });
    }
  });
};

class VoiceTranslater {
  voice = null;
  timerTimeout = null;
  isVoicing = false;

  options = {
    timeout: 5000,
    onTimeout: () => {},
    onRecognizing: () => {},
    onRecognized: () => {},
    onEnded: () => {},
  };

  constructor(options = {}) {
    this.options = {
      ...this.options,
      ...options,
    };
    this.setupTranslater();
  }

  initVoice() {
    this.voice = new VoiceRecorderAzure({
      onWillStatusChange: (prevStatus, nextStatus) => {
        if (nextStatus == 'runing') {
          this.handleTimeout();
        }
        this.options.onWillStatusChange(prevStatus, nextStatus);
      },

      onRecognizing: text => {
        if (!this.isVoicing) {
          return;
        }
        this.options.onRecognizing(text);

        // 有内容更新
        if (text) {
          this.handleTimeout();
        }
      },
      onRecognized: this.options.onRecognized,
      onEnded: this.options.onEnded,
      onError: error => {
        this.options.onError?.(error);
      },
    });
  }
  setupTranslater() {
    this.initVoice();
  }

  handleTimeout = () => {
    clearTimeout(this.timerTimeout);
    this.timerTimeout = setTimeout(() => {
      this.stop();
      this.options.onTimeout();
    }, this.options.timeout);
  };

  async start() {
    this.options.onWillStatusChange('', 'preflight');
    const { ok, error } = await checkAudioDevice();
    if (!ok) {
      this.options.onError?.(error);
      return;
    }
    this.isVoicing = true;
    this.voice.start();
  }

  stop() {
    setTimeout(() => {
      this.isVoicing = false;
    }, 0);
    this.voice.stop();
    clearTimeout(this.timerTimeout);
  }
}

export default VoiceTranslater;
